// "Back to top" button. HTML needs #pageup. Class `is-visible` toggled after 100px scroll.
// CSS handles fade via opacity transition — see _pageup.scss.
export function initPageUp() {
  const btn = document.getElementById('pageup');
  if (!btn) return;
  const onScroll = () => {
    btn.classList.toggle('is-visible', window.scrollY > 100);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // initial
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
